import React, { useContext, useState } from "react";
import { Block, PictureAsPdf, Print, ExitToApp, ChangeCircle, ChangeCircleOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";
import Context from "../../context/Context";
import language from "../../nls/language.json";
import './Molds.css'


export const REQUESTED_CANCELLATION = "SOLICITADO CANCELAMENTO";
export const RESERVED = "RESERVADO";
export const MAINTENANCE = "MANUTENCAO";
export const UNAVAILABLE = "INDISPONIVEL"
export const STOCK = "ESTOQUE";
export const CANCELED = "CANCELADO";
export const BLOCKED = "BLOQUEADO";
export const RELEASED = "LIBERADO";
export const PENDENT = "PENDENTE";

const CardMolds = ({
  data,
  handlePrint,
  handlePrintLabel,
  handleUpdataWagon,
  handleBlock,
  handleMoldCanceled,
  handleMoldChange,
  handleConfirmMold,
  furnaceEntryForecast,
  modal
}) => {
  const {
    selectedCountry
  } = useContext(Context);

  const handleStatusMold = (status) => {
    let badge = '';

    switch (status) {
      case "RESERVADO":
        badge = 'bg-success';
        break;
      case "MANUTENCAO":
        badge = 'bg-danger';
        break;
      default:
        badge = 'bg-secondary';
        break;
    }

    return (<span className={`badge ${badge}`}>{status}</span>)
  }


  const handleCheckBtnBlocked = (dataWagon) => {
    return !dataWagon.moldsWagon.some(({ mold, piece }) => mold.molde_Status === MAINTENANCE && !checkCanceled(mold))
      && !(dataWagon.wagon.isagA_Vagoes_Fornos_Pecas ?? []).some(({ status_Molde }) => status_Molde === MAINTENANCE || dataWagon.moldsWagon[0].mold.molde_Lote === "0000000")
  }

  const handleCheckBtnConfirmed = ({ moldsWagon, wagon }) => {
    const wagonPecas = wagon.isagA_Vagoes_Fornos_Pecas ?? [];
    const dataPecas = data.wagon.isagA_Vagoes_Fornos_Pecas ?? [];
    const checkWagon = wagonPecas.filter(item => !item.ativo).filter(item => moldsWagon.find(({ mold, piece }) => item.ordem_Serial === piece.ordem_Serial && mold.molde_Status === "RESERVADO"));
    const checkStatus = !moldsWagon.every(({ mold, piece }) => mold.molde_Status === RESERVED || dataPecas
      .some(item => !item.ativo && item.ordem_Serial === piece.ordem_Serial && mold.molde_Status === UNAVAILABLE));

    return !!checkWagon.length || checkStatus;
  }

  const handleCheckBtnFinished = (molds) =>
    !molds.every(({ mold }) => mold.molde_Status === STOCK || mold.molde_Status === MAINTENANCE || mold.molde_Lote === "0000000"
    )

  const checkCanceled = (mold) => (data.wagon.isagA_Vagoes_Fornos_Pecas ?? [])
    .some(item => item.molde_Key === mold.molde_Key && item.status_Molde === CANCELED)

  const checkCanceledNull = (piece) => (data.wagon.isagA_Vagoes_Fornos_Pecas ?? [])
    .some(item => !item.ativo && item.ordem_Serial === piece.ordem_Serial && item.status_Molde === CANCELED)

  const filterData = () => data.moldsWagon.filter(({ mold, piece }) => !(data.wagon.isagA_Vagoes_Fornos_Pecas ?? [])
    .some(item => !item.ativo && item.ordem_Serial === piece.ordem_Serial && mold.molde_Status === UNAVAILABLE));

  const isMoldConfirmable = (mold) =>
    mold.molde_Status !== RESERVED && mold.molde_Status !== MAINTENANCE && mold.molde_Status !== UNAVAILABLE;

  const handleConfirmAllMolds = async () => {
    const confirmable = filterData().filter(({ mold }) => isMoldConfirmable(mold));
    for (const { mold, piece } of confirmable) {
      await handleConfirmMold({
        vagaoKey: data.wagon.vagao_Key,
        moldKey: mold.molde_Key,
        ordemSerial: piece.ordem_Serial,
        qtd_Passagem: mold.molde_QtdPassagens,
        qtd_PassagemMax: mold.molde_QtdPassagensMAX,
        molde_Lote: mold.molde_Lote,
        molde_Codigo: mold.molde_Codigo,
        molde_Descricao: mold.molde_Descricao,
        molde_Estoque: mold.molde_Estoque,
      });
    }
  };



  return (
    <div className={`d-flex flex-column card-mold-container m-3 ${data.wagon.status_Vagao === REQUESTED_CANCELLATION ? "requested-cancellation-container" : ""}`}>
      <div className={`d-flex flex-row justify-content-start p-2 m-2 mb-1 mold-time`}>
        {furnaceEntryForecast && (
          <>
            <p className={`m-0 p-0 ms-2 fw-bold`}>LIBERAR VAGÃO ATÉ: </p>
            <p className={`m-0 p-0 ms-2 fw-bold`}>{furnaceEntryForecast}</p>
          </>
        )}
      </div>
      <div className={`d-flex flex-row justify-content-between wagon-container ${data.wagon.status_Vagao === REQUESTED_CANCELLATION ? "requested-cancellation-header" : ""}`}>
        <p className="ms-1 mb-0">VAGÃO: <span>{data.wagon.vagao_Serial}</span></p>
        <p className="ms-1 mb-0"><span>{data.typesPiecesCombinations.forno.toUpperCase()}</span></p>
        <p className="ms-1 mb-0">STATUS: <span>{data.wagon.status_Vagao}</span></p>
      </div>
      <table className="table-row text-center mb-2 mt-1 rounded-md">
        <thead>
          <tr>
            <th>{language[selectedCountry.name].Moldes.tableHeader.op}</th>
            <th className="d-none d-md-block">{language[selectedCountry.name].Moldes.tableHeader.lote}</th>
            <th></th>
            <th >{language[selectedCountry.name].Moldes.tableHeader.codigo}</th>
            <th className="d-none d-md-block">{language[selectedCountry.name].Moldes.tableHeader.descricao}</th>
            <th>{language[selectedCountry.name].Moldes.tableHeader.estoque}</th>
            <th>{language[selectedCountry.name].Moldes.tableHeader.status}</th>
            <th>
              {
                data.wagon.status_Vagao === REQUESTED_CANCELLATION
                  ? language[selectedCountry.name].Moldes.tableHeader.btnCancelar
                  : language[selectedCountry.name].Moldes.tableHeader.btnBloquear
              }
            </th>

            <th>Confirmar</th>

          </tr>
        </thead>
        <tbody>
          {filterData()?.map(({ mold, piece }, index) => (
            <tr
              key={`moldsInWagon-${index}`}
              className={`${mold.molde_Status === RESERVED
                ? 'mold-reserved' : (mold.molde_Status === MAINTENANCE || mold.molde_Status === UNAVAILABLE)
                  ? 'mold-blocked' : ''
                }`}
            >
              <td>{piece.ordem_Serial}</td>
              <td className="d-none d-md-block">{mold.molde_Lote}</td>
              <td>
                {mold.molde_Status === STOCK && (<ChangeCircleOutlined className="mold-change"
                  onClick={() => handleMoldChange({ vagaoKey: data.wagon.vagao_Key, moldKey: mold.molde_Key, ordemSerial: piece.ordem_Serial })}
                />
                )}</td>
              <td>{mold.molde_Codigo}</td>
              <td className="d-none d-md-block">{mold.molde_Descricao}</td>
              <td>{mold.molde_SAPLocal}</td>
              <td>{handleStatusMold(mold.molde_Status)}</td>
              <td>
                {((mold.molde_Status === MAINTENANCE && !checkCanceled(mold))
                  || mold.molde_Status === STOCK && checkCanceled(mold)
                  || !(mold.molde_Status === STOCK && checkCanceled(mold)) && data?.wagon.isagA_Vagoes_Fornos_Pecas.find(item => item.ordem_Serial === piece.ordem_Serial).status_Molde === MAINTENANCE)
                  ? <></>
                  : (data.wagon.status_Vagao === REQUESTED_CANCELLATION || (checkCanceled(mold) || checkCanceledNull(piece)))
                    ? (
                      <span className="mold-icon" data-tooltip={language[selectedCountry.name].Moldes.notification.apontarEstoque}>
                        <ExitToApp
                          className='btn-exit'
                          onClick={() => handleMoldCanceled({
                            vagaoKey: data.wagon.vagao_Key,
                            moldKey: mold.molde_Key,
                            ordemSerial: piece.ordem_Serial
                          })}
                        />
                      </span>
                    ) : (
                      <span className="mold-icon" data-tooltip={language[selectedCountry.name].Moldes.notification.apontarBloqueio}>
                        <Block
                          className={`${mold.molde_Status != UNAVAILABLE ? 'btn-block' : 'btn-block-blocked'}`}
                          onClick={() => handleBlock({
                            vagaoKey: data.wagon.vagao_Key,
                            moldKey: mold.molde_Key,
                            ordemSerial: piece.ordem_Serial,
                            moldLote: mold.molde_Lote
                          }, language[selectedCountry.name].Moldes.modal.adicionar.title)}
                        />
                      </span>
                    )}
              </td>

              <td>
                {mold.molde_Status !== RESERVED && mold.molde_Status !== MAINTENANCE && mold.molde_Status !== UNAVAILABLE && (
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: 'green',
                      color: '#fff',
                      textTransform: 'none',
                      boxShadow: 'none',
                      borderRadius: '6px',
                      fontSize: '10px',
                      padding: '4px 4px',
                      marginBottom: '10px'
                    }}
                    onClick={() => handleConfirmMold({
                      vagaoKey: data.wagon.vagao_Key,
                      moldKey: mold.molde_Key,
                      ordemSerial: piece.ordem_Serial,
                      qtd_Passagem: mold.molde_QtdPassagens,
                      qtd_PassagemMax: mold.molde_QtdPassagensMAX,
                      molde_Lote: mold.molde_Lote,
                      molde_Codigo: mold.molde_Codigo,
                      molde_Descricao: mold.molde_Descricao,
                      molde_Estoque: mold.molde_Estoque,
                    })}
                  >
                    Confirmar Molde
                  </Button>
                )}
              </td>

            </tr>
          ))}
        </tbody>
      </table>
      <div className="d-flex flex-row justify-content-between mx-sm-4 mx-md-0">
        {data.wagon.status_Vagao === REQUESTED_CANCELLATION ? (
          <div>
            <Button
              variant="contained"
              onClick={() => handleUpdataWagon(data, CANCELED)}
              disabled={handleCheckBtnFinished(data.moldsWagon)}
            >
              {language[selectedCountry.name].Moldes.btn.btnFinalizar}
            </Button>
          </div>
        ) : (
          <div>
            <Button
              className="ms-1"
              variant="contained"
              onClick={() => handleUpdataWagon(data, RELEASED)}
              disabled={handleCheckBtnConfirmed(data)}
            >
              {language[selectedCountry.name].Moldes.btn.btnConfirmar}
            </Button>
            <Button
              className="ms-1"
              variant="contained"
              onClick={() => handleUpdataWagon(data, BLOCKED)}
              disabled={handleCheckBtnBlocked(data)}
              color="error"
            >
              {language[selectedCountry.name].Moldes.btn.btnBloquear}
            </Button>
            <Button
              className="ms-1"
              variant="contained"
              onClick={handleConfirmAllMolds}
              disabled={!filterData().some(({ mold }) => isMoldConfirmable(mold))}
              style={{ backgroundColor: 'green', color: '#fff' }}
            >
              Confirmar Todos os Moldes
            </Button>
          </div>
        )}
        {data.wagon.status_Vagao !== REQUESTED_CANCELLATION && (
          <div className="d-flex flex-row">
            <Button
              onClick={() => handlePrint(data)}
            >
              <PictureAsPdf />
            </Button>
            <Button
              onClick={() => handlePrintLabel(data)}
            >
              <Print />
            </Button>
          </div>
        )}
      </div>


      { }
    </div>
  )
}

export default CardMolds;